export const toSelectValues = items =>
  items.map(item => ({
    value: item.id,
    label: item.name
  }))
